// extracted by mini-css-extract-plugin
export var statItem = "_je-1";
export var statsRow = "_je-0";